export default {
  LCI_SETUP_ROOT: 'lci_setup',
  LCI_LIVE_CODE: 'lci_live'
};
